export default "__VITE_ASSET__zQWE8CfZ__"